<template>
  <div class="tips">
    <img src="~@/assets/images/order/tip-down.png" />
    <div class="aflex v">
      <div>月嫂已发起上户请求</div>
      <div>上户时间：{{ applyDate }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['applyDate']
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.tips {
  width: rem(320px);
  position: absolute;
  top: rem(-110px);
  right: rem(44px);
  font-size: rem(26px);
  color: #ff6d00;
  line-height: 1.44;
  .v {
    padding-top: rem(20px);
    padding-left: rem(30px);
  }
  img {
    position: absolute;
    z-index: -1;
    width: rem(320px);
  }
}
</style>
